module.exports = __webpack_public_path__ + "static/img/图片1.58ed904f.png";